import { EEVENT_LABEL } from 'affiny-core/analytics';
import { useSelectCounters } from 'affiny-core/hooks';
import { ICounters } from 'affiny-core/modules/api/models/counters/counters.types';
import { Flex, IconName } from 'affiny-ui/src';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderNavListItem } from './HeaderNavListItem';

interface IMenuItem {
  label: string;
  icon: IconName;
  url: string;
  activeOnlyWhenExact: boolean;
  showPin?: boolean;
  eventLabel: EEVENT_LABEL;
}

export const HeaderNavList = () => {
  const { t } = useTranslation();
  const counters = useSelectCounters() as ICounters;

  const items: IMenuItem[] = useMemo(
    () => [
      {
        label: 'home',
        icon: 'home',
        url: '/home',
        activeOnlyWhenExact: true,
        eventLabel: EEVENT_LABEL.NAV_SELECTION_CLICK,
      },
      {
        label: 'explore',
        icon: 'list',
        url: '/explore',
        activeOnlyWhenExact: true,
        eventLabel: EEVENT_LABEL.NAV_LIST_CLICK,
      },
      {
        label: 'messages',
        icon: 'bubble',
        url: '/inbox',
        activeOnlyWhenExact: false,
        showPin: counters.message > 0,
        eventLabel: EEVENT_LABEL.NAV_MESSAGES_CLICK,
      },
      {
        label: 'favs',
        icon: 'heart',
        url: '/favorites-list',
        activeOnlyWhenExact: false,
        showPin: counters.favorite > 0,
        eventLabel: EEVENT_LABEL.NAV_FAVORITES_CLICK,
      },
      {
        label: 'visits',
        icon: 'profile-alt',
        url: '/visits',
        activeOnlyWhenExact: true,
        showPin: counters.visit > 0,
        eventLabel: EEVENT_LABEL.NAV_VISITES_CLICK,
      },
      {
        label: 'pictures',
        icon: 'padlock',
        url: '/photo-requests',
        activeOnlyWhenExact: true,
        showPin: counters.photoRequest > 0,
        eventLabel: EEVENT_LABEL.NAV_PHOTOS_CLICK,
      },
    ],
    [counters]
  );

  return (
    <Flex as="nav" height="100%" justifyContent="flex-end" flexDirection="row">
      {items.map((item, index) => (
        <HeaderNavListItem
          key={`item${index}`}
          {...item}
          label={t(`nav.items.${item.label}`)}
          disabled={item.url === '#'}
          activeOnlyWhenExact={item.activeOnlyWhenExact}
          data-test={`navigation-${item.label}`}
        />
      ))}
    </Flex>
  );
};
